/* ==========================================================================
   INBOUND CO. — Theme JS
   Cinematic interactions: cursor, parallax, magnetic, loader, reveals.
   ========================================================================== */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, event, fn, opts) => el && el.addEventListener(event, fn, opts);

  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  /* FREE SHIPPING PROGRESS -------------------------------------------------- */
  const FREE_SHIP_THRESHOLD = 499900; // ₹4,999 in paise

  function shipBarHTML(totalCents) {
    const pct = Math.min(100, (totalCents / FREE_SHIP_THRESHOLD) * 100);
    const unlocked = totalCents >= FREE_SHIP_THRESHOLD;
    const remaining = formatMoney(Math.max(0, FREE_SHIP_THRESHOLD - totalCents));

    const msg = unlocked
      ? `<span class="ship-bar__icon">
           <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
         </span><span><strong>Free shipping</strong> unlocked on this order</span>`
      : `<span class="ship-bar__icon">
           <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M1.5 4.5h9l1 2h2.5l1.5 3v3.5h-2M1.5 4.5v8h2M1.5 4.5L1 3M11.5 13a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM4.5 13a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
         </span><span>Add <strong>${remaining}</strong> more for free shipping</span>`;

    return `
      <div class="ship-bar${unlocked ? ' ship-bar--unlocked' : ''}" data-ship-bar>
        <div class="ship-bar__msg">${msg}</div>
        <div class="ship-bar__track"><div class="ship-bar__fill" style="width:${pct}%"></div></div>
      </div>`;
  }

  function showShipToast(totalCents) {
    const unlocked = totalCents >= FREE_SHIP_THRESHOLD;
    const remaining = formatMoney(Math.max(0, FREE_SHIP_THRESHOLD - totalCents));

    let stack = document.querySelector('.ship-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'ship-toast-stack';
      document.body.appendChild(stack);
    }
    // Only one toast at a time — clear any still-visible one instantly
    stack.innerHTML = '';

    const toast = document.createElement('div');
    toast.className = `ship-toast${unlocked ? '' : ' ship-toast--pending'}`;
    toast.innerHTML = unlocked
      ? `<span class="ship-toast__icon"><svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
         <span class="ship-toast__body">
           <span class="ship-toast__title">Free Shipping Unlocked</span>
           <span class="ship-toast__text">Applied automatically at checkout</span>
         </span>`
      : `<span class="ship-toast__icon"><svg viewBox="0 0 16 16" fill="none"><path d="M1.5 4.5h9l1 2h2.5l1.5 3v3.5h-2M1.5 4.5v8h2M1.5 4.5L1 3M11.5 13a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM4.5 13a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
         <span class="ship-toast__body">
           <span class="ship-toast__title">Added to Cart</span>
           <span class="ship-toast__text">Add <strong>${remaining}</strong> more for free shipping</span>
         </span>`;

    stack.appendChild(toast);
    requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('ship-toast--in')));

    setTimeout(() => {
      toast.classList.remove('ship-toast--in');
      toast.classList.add('ship-toast--out');
      setTimeout(() => toast.remove(), 340);
    }, 2600);
  }
  window.INBOUND_showShipToast = showShipToast;

  /* PAGE LOADER ----------------------------------------------------------- */
  function initLoader() {
    const loader = $('#page-loader');
    if (!loader) return;

    const start    = Date.now();
    const minDur   = 1400; // ~1.4s total — all 4 words, out fast
    const phrases  = ['SOURCING', 'AUTHENTICATING', 'DELIVERING', 'YOURS'];
    const phraseEl = document.getElementById('loader-phrase');
    let   scrambleRaf;

    /* — Scramble morph — fixed 160ms so all words feel equally snappy — */
    const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    function scrambleTo(target) {
      cancelAnimationFrame(scrambleRaf);
      const t0 = performance.now(), len = target.length;
      function frame(now) {
        const p      = Math.min((now - t0) / 160, 1);
        const locked = Math.round(p * len);
        let out = '';
        for (let i = 0; i < len; i++)
          out += i < locked ? target[i] : CHARS[Math.floor(Math.random() * 26)];
        phraseEl.textContent = out;
        if (p < 1) scrambleRaf = requestAnimationFrame(frame);
        else phraseEl.textContent = target;
      }
      scrambleRaf = requestAnimationFrame(frame);
    }

    /* — One cycle, all 4 words, 220ms apart — total ~880ms of phrases — */
    if (phraseEl) {
      phraseEl.classList.add('visible');
      phrases.forEach((phrase, i) => setTimeout(() => scrambleTo(phrase), i * 220));
    }

    /* — Dismiss: wait for minDur then fade out — */
    function dismiss() {
      const wait = Math.max(0, minDur - (Date.now() - start));
      setTimeout(() => {
        cancelAnimationFrame(scrambleRaf);
        loader.classList.add('loaded');
        setTimeout(() => { loader.style.display = 'none'; }, 450);
      }, wait);
    }

    if (document.readyState === 'complete') dismiss();
    else { window.addEventListener('load', dismiss); setTimeout(dismiss, 3000); }
  }

  /* CUSTOM CURSOR --------------------------------------------------------- */
  function initCursor() {
    if (window.matchMedia('(hover: none)').matches) return;

    const dot  = $('.cursor__dot');
    const ring = $('.cursor__ring');
    if (!dot || !ring) return;

    let mouseX = -100, mouseY = -100;
    let ringX  = -100, ringY  = -100;

    document.addEventListener('mousemove', e => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.transform = `translate(calc(${mouseX}px - 50%), calc(${mouseY}px - 50%))`;
    });

    (function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.transform = `translate(calc(${ringX}px - 50%), calc(${ringY}px - 50%))`;
      requestAnimationFrame(animateRing);
    })();

    const hoverTargets = 'a, button, [role="button"], .product-card, .brand-card, .filter-pill, .size-btn, .poll-option';

    document.addEventListener('mouseover', e => {
      if (e.target.closest(hoverTargets)) document.body.classList.add('cursor-hover');
    });

    document.addEventListener('mouseout', e => {
      if (e.target.closest(hoverTargets)) document.body.classList.remove('cursor-hover');
    });

    document.addEventListener('mouseleave', () => { dot.style.opacity = '0'; ring.style.opacity = '0'; });
    document.addEventListener('mouseenter', () => { dot.style.opacity = '1'; ring.style.opacity = '1'; });

    /* Keep cursor visible over QV overlay — re-attach tracking to overlay events */
    document.addEventListener('mousemove', e => {
      /* Ensure cursor stays visible whenever mouse moves anywhere on page */
      dot.style.opacity = '1';
      ring.style.opacity = '1';
    }, { passive: true });
  }

  /* HERO PARALLAX --------------------------------------------------------- */
  function initParallax() {
    const heroBg = $('.hero__bg-img') || $('.hero__bg-video');
    if (!heroBg) return;
    let ticking = false;
    function update() {
      const hero = $('.hero');
      if (!hero) return;
      const pct = Math.min(window.scrollY / hero.offsetHeight, 1);
      heroBg.style.transform = `scale(1.08) translateY(${pct * 28}%)`;
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* MAGNETIC BUTTONS ------------------------------------------------------ */
  function initMagneticButtons() {
  }

  /* PRODUCT CARD SPOTLIGHT ------------------------------------------------ */
  function initCardSpotlight() {
    if (window.matchMedia('(hover: none)').matches) return;
    $$('.product-card').forEach(card => {
      if (!card.querySelector('.product-card__spotlight')) {
        const spot = document.createElement('div');
        spot.className = 'product-card__spotlight';
        card.querySelector('.product-card__image-wrap')?.prepend(spot);
      }
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - r.left) / r.width  * 100) + '%');
        card.style.setProperty('--my', ((e.clientY - r.top)  / r.height * 100) + '%');
      });
    });
  }

  /* SCROLL REVEALS -------------------------------------------------------- */
  function initScrollReveals() {
    const els = $$('.reveal, .reveal-left, .reveal-scale, .fade-in');
    if (!els.length) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -80px 0px' });
    els.forEach(el => { if (!el.closest('.hero')) observer.observe(el); });
  }

  /* STAGGERED GRID REVEALS ------------------------------------------------ */
  function initGridReveals() {
    $$('.product-grid, .brands-grid').forEach(grid => {
      const isBrand = grid.classList.contains('brands-grid');
      const cards   = $$(isBrand ? '.brand-card' : '.product-card', grid);

      function revealCards() {
        cards.forEach((c, i) => {
          // reset transitionDelay per card for stagger
          c.style.transitionDelay = `${i * 55}ms`;
          c.style.opacity   = '1';
          c.style.transform = 'translateY(0)';
        });
      }

      cards.forEach((card, i) => {
        card.style.opacity         = '0';
        card.style.transform       = 'translateY(28px)';
        card.style.transition      = 'opacity 800ms ease, transform 800ms cubic-bezier(0.16,1,0.3,1)';
        card.style.transitionDelay = `${i * 90}ms`;
      });

      // Check if already visible (Chrome often skips the first callback)
      const rect = grid.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        revealCards();
        return;
      }

      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { revealCards(); obs.disconnect(); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      obs.observe(grid);

      // Hard fallback: if observer never fires (Chrome tab-background edge case), reveal after 800ms
      setTimeout(() => revealCards(), 800);
    });
  }

  /* HEADER ---------------------------------------------------------------- */
  function initHeader() {
    const header     = $('.site-header');
    const hamburger  = $('#hamburger');
    const mobileMenu = $('#mobile-menu');
    if (!header) return;

    let menuOverlay = $('#mobile-menu-overlay');
    if (!menuOverlay) {
      menuOverlay = document.createElement('div');
      menuOverlay.id = 'mobile-menu-overlay';
      menuOverlay.className = 'mobile-menu-overlay';
      document.body.appendChild(menuOverlay);
    }

    window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 10), { passive: true });
    header.classList.toggle('scrolled', window.scrollY > 10);

    const openMenu  = () => { mobileMenu.classList.add('open'); menuOverlay.classList.add('open'); hamburger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; };
    const closeMenu = () => { mobileMenu.classList.remove('open'); menuOverlay.classList.remove('open'); hamburger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };

    on(hamburger, 'click', () => mobileMenu.classList.contains('open') ? closeMenu() : openMenu());
    on(menuOverlay, 'click', closeMenu);
    on($('#mobile-menu-close'), 'click', closeMenu);
    $$('.mobile-menu__link').forEach(l => on(l, 'click', closeMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
  }

  /* CART DRAWER ----------------------------------------------------------- */
  function initCart() {
    const cartOverlay = $('#cart-overlay');
    const cartDrawer  = $('#cart-drawer');
    const cartClose   = $('#cart-close');
    const cartBtns    = $$('[data-open-cart]');
    const cartBody    = $('#cart-body');
    const cartFooter  = $('#cart-footer');

    const openCart  = () => { cartOverlay.classList.add('open'); cartDrawer.classList.add('open'); document.body.style.overflow = 'hidden'; renderCart(); };
    const closeCart = () => { cartOverlay.classList.remove('open'); cartDrawer.classList.remove('open'); document.body.style.overflow = ''; };

    cartBtns.forEach(btn => on(btn, 'click', openCart));
    on(cartClose, 'click', closeCart);
    on(cartOverlay, 'click', closeCart);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

    async function renderCart() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (!cartBody) return;

        if (cart.item_count === 0) {
          cartBody.innerHTML = `<div class="cart-drawer__empty"><p style="font-family:var(--font-bold);font-size:1.1rem;text-transform:uppercase;margin-bottom:8px;">Cart is empty</p><p style="color:var(--grey-300);margin-bottom:28px;font-size:13px;">Add something iconic.</p><a href="/collections/all" class="btn btn--outline" onclick="document.getElementById('cart-close').click()">Browse Now</a></div>`;
          cartFooter.innerHTML = '';
          return;
        }

        cartBody.innerHTML = cart.items.map((item, i) => {
          const sizeOpt = item.options_with_values && item.options_with_values.find(o => o.name.toLowerCase() === 'size');
          const sizeVal = sizeOpt ? sizeOpt.value : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
          return `
          <div class="cart-item" data-unit-price="${item.price}">
            <a href="${item.url}" class="cart-item__img-wrap">
              <img class="cart-item__img" src="${item.image}" alt="${item.product_title}" loading="lazy">
            </a>
            <div class="cart-item__body">
              <div class="cart-item__brand">${item.vendor}</div>
              <div class="cart-item__name">${item.product_title}</div>
              ${sizeVal ? `<div class="cart-item__size">${sizeVal}</div>` : ''}
              <div class="cart-item__footer">
                <div class="qty-control">
                  <button class="qty-btn" data-action="decrement" data-line="${i + 1}" data-qty="${item.quantity}">−</button>
                  <span class="qty-val">${item.quantity}</span>
                  <button class="qty-btn" data-action="increment" data-line="${i + 1}" data-qty="${item.quantity}">+</button>
                </div>
                <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
              </div>
            </div>
          </div>`;
        }).join('');

        const shipUnlocked = cart.total_price >= FREE_SHIP_THRESHOLD;

        cartFooter.innerHTML = `
          <div class="cart-drawer__footer-inner">

            ${shipBarHTML(cart.total_price)}

            <div class="cart-drawer__delivery-strip">
              <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/><path d="M8 5v3.2l2 1.3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
              <span>Estimated delivery <strong>3–4 weeks</strong> after order</span>
            </div>

            <div class="cart-drawer__totals">
              <div class="cart-drawer__total-row">
                <span class="cart-drawer__total-label">Subtotal</span>
                <span class="cart-subtotal__price">${formatMoney(cart.total_price)}</span>
              </div>
              <div class="cart-drawer__total-row">
                <span class="cart-drawer__total-label">Shipping</span>
                <span class="cart-drawer__free${shipUnlocked ? '' : ' cart-drawer__free--pending'}">${shipUnlocked ? 'Free' : formatMoney(19900)}</span>
              </div>
            </div>

            <div class="cart-drawer__divider"></div>

            <a href="/checkout" class="cart-drawer__checkout">
              <span>Proceed to Checkout</span>
              <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>

            <div class="cart-drawer__trust-grid">
              <div class="cart-drawer__trust-badge">
                <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="2" y="7" width="12" height="8" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
                <span>No hidden charges</span>
              </div>
              <div class="cart-drawer__trust-badge">
                <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 1l1.5 3 3.5.5-2.5 2.5.6 3.5L8 9l-3.1 1.5.6-3.5L3 4.5 6.5 4 8 1z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>
                <span>Personally sourced</span>
              </div>
              <div class="cart-drawer__trust-badge">
                <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/><path d="M2 8h12M8 2c-2 2-3 4-3 6s1 4 3 6M8 2c2 2 3 4 3 6s-1 4-3 6" stroke="currentColor" stroke-width="1.2"/></svg>
                <span>Globally verified</span>
              </div>
            </div>

          </div>`;

        $$('.qty-btn', cartBody).forEach(btn => {
          let _busy = false;
          on(btn, 'click', async () => {
            if (_busy) return;
            _busy = true;

            const line   = parseInt(btn.dataset.line);
            const curQty = parseInt(btn.dataset.qty);
            const newQty = btn.dataset.action === 'increment' ? curQty + 1 : Math.max(0, curQty - 1);

            // Instant optimistic UI — no waiting
            const ctrl      = btn.closest('.qty-control');
            const qtySpan   = ctrl && ctrl.querySelector('.qty-val');
            if (qtySpan) qtySpan.textContent = newQty;
            ctrl && ctrl.querySelectorAll('.qty-btn').forEach(b => b.dataset.qty = newQty);

            const cartItemEl  = btn.closest('.cart-item');
            const unitPrice   = cartItemEl && parseInt(cartItemEl.dataset.unitPrice);
            const linePriceEl = cartItemEl && cartItemEl.querySelector('.cart-item__price');
            if (linePriceEl && unitPrice) linePriceEl.textContent = formatMoney(unitPrice * newQty);

            try {
              const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line, quantity: newQty })
              });
              const cart = await res.json();
              if (!res.ok) throw new Error(cart.message || 'Cart update failed');

              // Update subtotal + count from the single response — no extra fetch
              const subtotalEl = cartFooter.querySelector('.cart-subtotal__price');
              if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
              $$('.cart-count').forEach(b => { b.textContent = cart.item_count; b.dataset.count = cart.item_count; });

              // Refresh shipping progress bar + shipping row in place
              const shipBarEl = cartFooter.querySelector('[data-ship-bar]');
              if (shipBarEl) shipBarEl.outerHTML = shipBarHTML(cart.total_price);
              const shipRowEl = cartFooter.querySelector('.cart-drawer__free');
              if (shipRowEl) {
                const nowUnlocked = cart.total_price >= FREE_SHIP_THRESHOLD;
                shipRowEl.textContent = nowUnlocked ? 'Free' : formatMoney(19900);
                shipRowEl.classList.toggle('cart-drawer__free--pending', !nowUnlocked);
              }

              // Item removed — re-render with data we already have
              if (newQty === 0) {
                if (cart.item_count === 0) {
                  cartBody.innerHTML = `<div class="cart-drawer__empty"><p style="font-family:var(--font-bold);font-size:1.1rem;text-transform:uppercase;margin-bottom:8px;">Cart is empty</p><p style="color:var(--grey-300);margin-bottom:28px;font-size:13px;">Add something iconic.</p><a href="/collections/all" class="btn btn--outline" onclick="document.getElementById('cart-close').click()">Browse Now</a></div>`;
                  cartFooter.innerHTML = '';
                } else {
                  renderCart();
                }
              }
            } catch (e) {
              // Revert optimistic update on error
              if (qtySpan) qtySpan.textContent = curQty;
              ctrl && ctrl.querySelectorAll('.qty-btn').forEach(b => b.dataset.qty = curQty);
              if (linePriceEl && unitPrice) linePriceEl.textContent = formatMoney(unitPrice * curQty);
            } finally {
              _busy = false;
            }
          });
        });
      } catch (err) { console.error('Cart:', err); }
    }

    document.addEventListener('submit', async e => {
      const form = e.target;
      if (!form.matches('[data-atc-form]')) return;
      e.preventDefault();
      const btn = form.querySelector('[data-atc-btn]');
      const orig = btn.textContent;
      btn.textContent = 'Adding…'; btn.disabled = true;
      try {
        await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        updateCartCount(); btn.textContent = '✓ Added';
        fetch('/cart.js').then(r => r.json()).then(cart => showShipToast(cart.total_price)).catch(() => {});
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; openCart(); }, 800);
      } catch { btn.textContent = 'Error'; btn.disabled = false; }
    });

    async function updateCartCount() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        $$('.cart-count').forEach(b => { b.textContent = cart.item_count; b.dataset.count = cart.item_count; });
      } catch {}
    }
  }

  /* SEARCH ---------------------------------------------------------------- */
  function initSearch() {
    const overlay  = $('#search-overlay');
    const backdrop = $('#search-backdrop');
    const close    = $('#search-close');
    const input    = $('#search-input');
    const results  = $('#search-results');
    if (!overlay) return;

    let activeIdx = -1;
    let debounceTimer = null;

    const open = () => {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { input?.focus(); }, 80);
    };
    const shut = () => {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      if (results) results.innerHTML = '';
      if (input)   input.value = '';
      activeIdx = -1;
    };

    $$('[data-open-search]').forEach(btn => on(btn, 'click', open));
    on(close,    'click', shut);
    on(backdrop, 'click', shut);

    document.addEventListener('keydown', e => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); open(); }
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'Escape') { shut(); return; }

      const items = results ? results.querySelectorAll('.search-result-item') : [];
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIdx = (activeIdx + 1) % items.length;
        setActive(items, activeIdx);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIdx = (activeIdx - 1 + items.length) % items.length;
        setActive(items, activeIdx);
      } else if (e.key === 'Enter' && activeIdx >= 0) {
        items[activeIdx].click();
      }
    });

    function setActive(items, idx) {
      items.forEach((el, i) => el.classList.toggle('active', i === idx));
      items[idx]?.scrollIntoView({ block: 'nearest' });
    }

    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        const q = input.value.trim();
        activeIdx = -1;
        if (!q) { results.innerHTML = ''; return; }
        debounceTimer = setTimeout(() => fetchResults(q), 200);
      });
    }

    async function fetchResults(q) {
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
        const data = await fetch(url).then(r => r.json());
        renderResults(data.resources?.results || {}, q);
      } catch {
        results.innerHTML = `<p class="search-overlay__empty">Something went wrong — try again</p>`;
      }
    }

    function renderResults(res, q) {
      const products    = res.products    || [];
      const collections = res.collections || [];
      if (!products.length && !collections.length) {
        results.innerHTML = `<p class="search-overlay__empty">No results for "<strong>${q}</strong>"</p>`;
        return;
      }

      let html = '';

      if (products.length) {
        html += `<div class="search-results__label">Products</div>`;
        products.forEach((p, i) => {
          const price = p.price ? `₹${Math.round(parseFloat(p.price)).toLocaleString('en-IN')}` : '';
          const delay = `animation-delay:${i * 50}ms`;
          const img   = p.featured_image?.url
            ? `<img class="search-result-item__thumb" src="${p.featured_image.url}&width=80" alt="${p.title}" loading="lazy">`
            : `<div class="search-result-item__thumb search-result-item__thumb--placeholder">◻</div>`;
          html += `
            <a class="search-result-item" href="${p.url}" style="${delay}">
              ${img}
              <div class="search-result-item__info">
                <div class="search-result-item__title">${p.title}</div>
                <div class="search-result-item__meta">${p.product_type || ''}</div>
              </div>
              ${price ? `<span class="search-result-item__price">${price}</span>` : ''}
            </a>`;
        });
      }

      if (collections.length) {
        html += `<div class="search-results__label">Collections</div>`;
        collections.forEach(c => {
          html += `
            <a class="search-result-item" href="${c.url}">
              <div class="search-result-item__thumb search-result-item__thumb--placeholder">≡</div>
              <div class="search-result-item__info">
                <div class="search-result-item__title">${c.title}</div>
                <div class="search-result-item__meta">Collection</div>
              </div>
            </a>`;
        });
      }

      results.innerHTML = html;
      activeIdx = -1;
    }
  }

  /* PRODUCT IMAGES — mobile carousel + desktop thumb rail --------------- */
  function initProductImages() {
    // ── Mobile carousel ──
    const track    = document.getElementById('img-track');
    const dots     = document.querySelectorAll('.product-images__dot');
    const carousel = document.getElementById('img-carousel');

    if (track) {
      let current = 0;
      const slides = track.querySelectorAll('.product-images__carousel-slide');
      const total  = slides.length;

      function goTo(idx) {
        current = (idx + total) % total;
        track.style.transform = `translateX(-${current * 100}%)`;
        dots.forEach((d, i) => d.classList.toggle('active', i === current));
      }

      dots.forEach(dot => {
        dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
      });

      if (carousel) {
        let startX = 0, dragging = false;
        carousel.addEventListener('touchstart', e => { startX = e.touches[0].clientX; dragging = true; }, { passive: true });
        carousel.addEventListener('touchend',   e => {
          if (!dragging) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
          dragging = false;
        }, { passive: true });
      }
    }

    // ── Desktop thumbnail rail ──
    const mainImg = document.getElementById('img-main');
    const thumbs  = document.querySelectorAll('.product-images__thumb');

    if (mainImg && thumbs.length) {
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.src;
          if (!src || mainImg.src.includes(src.split('?')[0].split('/').pop())) return;

          // Fade out → swap → fade in
          mainImg.classList.add('switching');
          setTimeout(() => {
            mainImg.src = src;
            mainImg.onload = () => mainImg.classList.remove('switching');
          }, 180);

          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    }
  }

  /* SIZE SELECTOR --------------------------------------------------------- */
  function initSizeSelector() {
    const btns  = $$('.size-btn');
    const input = $('#variant-id');
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (input) input.value = btn.dataset.variantId;
      });
    });
    // Auto-select first available size without triggering click event bubbling
    const first = btns.find(b => !b.disabled);
    if (first) {
      btns.forEach(b => b.classList.remove('active'));
      first.classList.add('active');
      if (input) input.value = first.dataset.variantId;
    }
  }

  /* SIZE GUIDE ------------------------------------------------------------ */
  function initSizeGuide() {
    const overlay = $('#size-guide-overlay');
    const open    = () => { overlay?.classList.add('open');    document.body.style.overflow = 'hidden'; };
    const close   = () => { overlay?.classList.remove('open'); document.body.style.overflow = ''; };
    $$('.size-guide-link').forEach(b => on(b, 'click', open));
    $$('.modal__close, #size-guide-close').forEach(b => on(b, 'click', close));
    on(overlay, 'click', e => { if (e.target === overlay) close(); });
  }

  /* ACCORDION ------------------------------------------------------------- */
  function initAccordions() {
    $$('.accordion-trigger').forEach(trigger => {
      on(trigger, 'click', () => {
        const item   = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('open');
        $$('.accordion-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
    const first = $('.accordion-item');
    if (first) first.classList.add('open');
  }

  /* MII CARD SCROLL REVEAL ------------------------------------------------ */
  function initMiiCard() {
    var card = document.getElementById('hero-mii-card');
    if (!card) return;

    function reveal() {
      card.classList.add('mii-revealed');
    }

    var io = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) { reveal(); io.disconnect(); }
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

    io.observe(card);

    /* Already in viewport on load (desktop) */
    setTimeout(function() {
      var r = card.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        reveal(); io.disconnect();
      }
    }, 800);
  }

  /* POLL ------------------------------------------------------------------ */
  function initPoll() {
    const pollEl = $('#drop-poll');
    if (!pollEl) return;
    const KEY  = 'inbound_drop_vote';
    const defs = { lululemon: 489, alo: 312, breathedivinity: 201, dfyne: 167, aybl: 143 };
    const getVotes    = () => { try { const s = localStorage.getItem(KEY+'_counts'); return s ? JSON.parse(s) : {...defs}; } catch { return {...defs}; } };
    const saveVotes   = v  => { try { localStorage.setItem(KEY+'_counts', JSON.stringify(v)); } catch {} };
    const hasVoted    = () => { try { return !!localStorage.getItem(KEY); } catch { return false; } };
    const saveVote    = b  => { try { localStorage.setItem(KEY, b); } catch {} };
    const getVotedFor = () => { try { return localStorage.getItem(KEY) || ''; } catch { return ''; } };

    let pendingBrand = null;

    function render() {
      const votes = getVotes(), voted = hasVoted(), user = getVotedFor();
      const total = Object.values(votes).reduce((a,b) => a+b, 0);
      $$('.poll-option', pollEl).forEach(opt => {
        const brand = opt.dataset.brand;
        const pct   = total > 0 ? Math.round((votes[brand]||0) / total * 100) : 0;
        const fill  = opt.querySelector('.poll-option__bar-fill');
        const pctEl = opt.querySelector('.poll-option__pct');
        if (fill)  fill.style.width  = pct + '%';
        if (pctEl) pctEl.textContent = pct + '%';
        opt.style.cursor = voted ? 'default' : 'pointer';
        opt.classList.toggle('voted', voted && brand === user);
        opt.classList.toggle('poll-option--done', voted && brand !== user);
      });
      const vEl  = pollEl.querySelector('.poll-widget__votes');
      const vMsg = pollEl.querySelector('.poll-widget__voted-msg');
      if (vEl)  vEl.textContent = total.toLocaleString('en-IN') + ' votes';
      if (vMsg) vMsg.style.display = voted ? 'block' : 'none';
    }

    /* Open gate modal */
    function openGate(brand, name) {
      pendingBrand = brand;
      const gate = $('#poll-gate');
      const brandEl = $('#poll-gate-brand');
      const input   = $('#poll-gate-input');
      const errEl   = $('#poll-gate-err');
      if (!gate) { castVote(brand, null); return; }
      if (brandEl) brandEl.textContent = name;
      if (input)   input.value = '';
      if (errEl)   errEl.style.display = 'none';
      gate.removeAttribute('aria-hidden');
      gate.classList.add('poll-gate--open');
      setTimeout(() => { if (input) input.focus(); }, 120);
    }

    function closeGate() {
      const gate = $('#poll-gate');
      if (gate) { gate.setAttribute('aria-hidden', 'true'); gate.classList.remove('poll-gate--open'); }
      pendingBrand = null;
    }

    function castVote(brand, phone) {
      const votes = getVotes();
      votes[brand] = (votes[brand]||0) + 1;
      saveVotes(votes);
      saveVote(brand);
      /* Submit to Shopify contacts for server-side tracking */
      if (phone) {
        try {
          const fb = document.getElementById('poll-form-brand');
          const fp = document.getElementById('poll-form-phone');
          const fc = document.getElementById('poll-contact-form');
          if (fb) fb.value = brand;
          if (fp) fp.value = '+91' + phone;
          if (fc) fc.submit();
        } catch(e) {}
      }
      render();
    }

    /* Poll option clicks → open gate */
    $$('.poll-option', pollEl).forEach(opt => {
      on(opt, 'click', () => {
        if (hasVoted()) return;
        const brand = opt.dataset.brand;
        const name  = opt.dataset.name || opt.querySelector('.poll-option__name')?.textContent || brand;
        if (!brand) return;
        openGate(brand, name);
      });
    });

    /* Gate submit */
    const submitBtn = $('#poll-gate-submit');
    const closeBtn  = $('#poll-gate-close');
    const gateEl    = $('#poll-gate');
    const inputEl   = $('#poll-gate-input');
    const errEl     = $('#poll-gate-err');

    if (submitBtn) on(submitBtn, 'click', () => {
      const phone = inputEl ? inputEl.value.trim() : '';
      if (!/^[0-9]{10}$/.test(phone)) {
        if (errEl) errEl.style.display = 'block';
        return;
      }
      if (errEl) errEl.style.display = 'none';
      castVote(pendingBrand, phone);
      closeGate();
    });
    if (closeBtn) on(closeBtn, 'click', closeGate);
    if (gateEl)   on(gateEl, 'click', e => { if (e.target === gateEl) closeGate(); });
    if (inputEl)  on(inputEl, 'keydown', e => { if (e.key === 'Enter' && submitBtn) submitBtn.click(); });

    render();
    new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) render(); });
    }, { threshold: 0.3 }).observe(pollEl);
  }

  /* NOTIFY FORM ----------------------------------------------------------- */
  function initNotifyForm() {
    const form = $('#drop-notify-form');
    if (!form) return;
    on(form, 'submit', e => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn   = form.querySelector('button');
      if (!input?.value) return;
      btn.textContent = '…';
      setTimeout(() => { btn.textContent = '✓ Done'; input.value = ''; setTimeout(() => btn.textContent = 'Notify Me', 2500); }, 600);
    });
  }

  /* FILTERS --------------------------------------------------------------- */
  function initFilters() {
    $$('.filter-pill').forEach(pill => {
      on(pill, 'click', () => {
        $$('.filter-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        const v = pill.dataset.value;
        window.location.href = (v && v !== 'all') ? '?filter.p.tag=' + encodeURIComponent(v) : window.location.pathname;
      });
    });

    // Custom sort dropdown
    const sortWrap = $('#sort-dropdown');
    const sortBtn  = $('#sort-btn');
    const sortMenu = $('#sort-menu');
    if (sortWrap && sortBtn && sortMenu) {
      on(sortBtn, 'click', (e) => {
        e.stopPropagation();
        sortWrap.classList.toggle('open');
      });
      document.addEventListener('click', () => sortWrap.classList.remove('open'));
      $$('.collection-sort__option').forEach(opt => {
        on(opt, 'click', () => {
          const val = opt.dataset.value;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', val);
          window.location.href = url.toString();
        });
      });
    }
  }

  /* TICKER ---------------------------------------------------------------- */
  function initTicker() {
    const track = $('.ticker-track');
    if (!track) return;
    track.parentNode.appendChild(track.cloneNode(true));
  }

  /* ANNOUNCEMENT ---------------------------------------------------------- */
  function initAnnouncement() {
    const bar = $('#announcement-bar'), close = $('#announcement-close');
    if (!bar || !close) return;
    on(close, 'click', () => { bar.style.display = 'none'; try { sessionStorage.setItem('inbound_ann', '1'); } catch {} });
    try { if (sessionStorage.getItem('inbound_ann')) bar.style.display = 'none'; } catch {}
  }

  /* LAZY IMAGES ----------------------------------------------------------- */
  function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.src = e.target.dataset.src || e.target.src; obs.unobserve(e.target); } });
    });
    $$('img[loading="lazy"]').forEach(img => obs.observe(img));
  }

  /* HERO HEADLINE — wrap in double span for line reveal ------------------- */
  function initHeroHeadline() {
    $$('.hero__headline > span').forEach(span => {
      if (!span.querySelector('span')) {
        const inner = document.createElement('span');
        inner.innerHTML = span.innerHTML;
        span.innerHTML  = '';
        span.appendChild(inner);
      }
    });
  }

  /* BRAND MANIFEST — floating preview follows cursor over brand rows ------ */
  function initBrandManifest() {
    const manifest = $('#brand-manifest');
    const preview  = $('#manifest-preview');
    if (!manifest || !preview) return;
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let tx = 0, ty = 0;   // target
    let cx = 0, cy = 0;   // current (lerped)
    let raf = null;
    let open = false;

    function loop() {
      cx += (tx - cx) * 0.13;
      cy += (ty - cy) * 0.13;
      // tilt with horizontal velocity, clamped
      const rot = Math.max(-9, Math.min(9, (tx - cx) * 0.08));
      preview.style.left = cx + 'px';
      preview.style.top  = cy + 'px';
      preview.style.setProperty('--mp-rot', rot.toFixed(2) + 'deg');
      if (open || Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = null;
      }
    }

    function startLoop() { if (!raf) raf = requestAnimationFrame(loop); }

    function populate(row) {
      const imgs = (row.dataset.images || '').split('|').filter(Boolean);
      if (imgs.length) {
        preview.innerHTML = '<div class="manifest-preview__fan">' +
          imgs.map(src => '<img class="manifest-preview__img" src="' + src + '" alt="" loading="eager">').join('') +
          '</div>';
      } else {
        preview.innerHTML =
          '<div class="manifest-preview__card">' +
            '<div class="manifest-preview__card-brand">' + (row.dataset.brand || '') + '</div>' +
            '<div class="manifest-preview__card-status">' + (row.dataset.statusLabel || 'Coming soon') + '</div>' +
          '</div>';
      }
    }

    $$('.manifest-row', manifest).forEach(row => {
      on(row, 'mouseenter', e => {
        populate(row);
        tx = e.clientX; ty = e.clientY;
        if (!open) { cx = tx; cy = ty; }   // first open: no fly-in from old spot
        open = true;
        preview.classList.add('is-open');
        startLoop();
      });
      on(row, 'mousemove', e => {
        tx = e.clientX; ty = e.clientY;
        startLoop();
      });
    });

    on(manifest, 'mouseleave', () => {
      open = false;
      preview.classList.remove('is-open');
    });
  }

  /* INIT ------------------------------------------------------------------ */
  function init() {
    initLoader();
    initCursor();
    initHeroHeadline();
    initParallax();
    initMagneticButtons();
    initCardSpotlight();
    initScrollReveals();
    initGridReveals();
    initHeader();
    initCart();
    initSearch();
    initProductImages();
    initSizeSelector();
    initSizeGuide();
    initAccordions();
    initMiiCard();
    initPoll();
    initNotifyForm();
    initFilters();
    initTicker();
    initAnnouncement();
    initLazyImages();
    initBrandManifest();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();

/* =========================================================================
   INBOUND CO. — Animation Extensions
   Page transitions, section reveals, 3D tilt, shimmer
   ========================================================================= */

(function () {
  'use strict';

  /* PAGE TRANSITION WIPE -------------------------------------------------- */
  function initPageTransition() {
    // Inject wipe element
    let wipe = document.getElementById('page-transition');
    if (!wipe) {
      wipe = document.createElement('div');
      wipe.id = 'page-transition';
      wipe.className = 'page-transition';
      document.body.appendChild(wipe);
    }

    // Wipe out on all internal link clicks
    document.addEventListener('click', e => {
      const link = e.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href) return;

      // Skip: external, hash, shopify special, javascript, open-in-new
      const isExternal  = link.hostname !== window.location.hostname;
      const isHash      = href.startsWith('#');
      const isSpecial   = href.startsWith('javascript') || href.startsWith('mailto') || href.startsWith('tel');
      const isNewTab    = link.target === '_blank';
      const isShopifyAjax = href.includes('/cart/') || href.includes('.js');

      if (isExternal || isHash || isSpecial || isNewTab || isShopifyAjax) return;

      e.preventDefault();
      wipe.classList.remove('wipe-out');
      wipe.classList.add('wipe-in');
      sessionStorage.setItem('inbound-wipe', '1');

      setTimeout(() => {
        window.location.href = href;
      }, 480);
    });

    // Wipe out only if we navigated here via a wipe-in (tracked in sessionStorage)
    window.addEventListener('pageshow', (e) => {
      const cameFromWipe = sessionStorage.getItem('inbound-wipe') === '1';
      sessionStorage.removeItem('inbound-wipe');
      if (!cameFromWipe && !e.persisted) return; // fresh load, not a wipe nav — skip
      wipe.style.transform = 'translateY(0%)'; // ensure it's covering before animating out
      requestAnimationFrame(() => {
        wipe.classList.remove('wipe-in');
        wipe.classList.add('wipe-out');
        setTimeout(() => {
          wipe.classList.remove('wipe-in', 'wipe-out');
          wipe.style.transform = '';
        }, 600);
      });
    });
  }

  /* SECTION IN-VIEW ------------------------------------------------------- */
  function initSectionReveals() {
    const sections = document.querySelectorAll('.section, .drop-section, .site-footer');
    if (!sections.length) return;

    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    sections.forEach(s => obs.observe(s));
  }

  /* 3D CARD TILT ---------------------------------------------------------- */
  function initCardTilt() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.product-card, .brand-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r  = card.getBoundingClientRect();
        const cx = r.left + r.width  / 2;
        const cy = r.top  + r.height / 2;
        const dx = (e.clientX - cx) / (r.width  / 2);
        const dy = (e.clientY - cy) / (r.height / 2);
        const tiltX =  dy * -4;
        const tiltY =  dx *  4;
        card.style.transform = `perspective(800px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.01)`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transition = 'transform 500ms cubic-bezier(0.16,1,0.3,1)';
        card.style.transform  = 'perspective(800px) rotateX(0deg) rotateY(0deg) scale(1)';
        setTimeout(() => { card.style.transition = ''; }, 500);
      });
    });
  }

  /* GOLD SHIMMER ON LOGO MARK --------------------------------------------- */
  function initLogoShimmer() {
    const mark = document.querySelector('.site-logo__mark');
    if (!mark) return;

    // Pulse the gold bar with a shimmer every few seconds
    setInterval(() => {
      mark.style.transition = 'opacity 300ms ease';
      mark.style.opacity = '0.4';
      setTimeout(() => { mark.style.opacity = '1'; }, 300);
    }, 4000);
  }

  /* STAGGER FOOTER LINKS -------------------------------------------------- */
  function initFooterReveal() {
    const footer = document.querySelector('.site-footer');
    if (!footer) return;

    const cols = footer.querySelectorAll('.footer-col, .footer-brand');
    cols.forEach((col, i) => {
      col.style.opacity   = '0';
      col.style.transform = 'translateY(20px)';
      col.style.transition = `opacity 600ms ease, transform 600ms cubic-bezier(0.16,1,0.3,1)`;
      col.style.transitionDelay = `${i * 80}ms`;
    });

    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          cols.forEach(col => {
            col.style.opacity   = '1';
            col.style.transform = 'translateY(0)';
          });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    obs.observe(footer);
  }

  /* TICKER — pause hint removed */
  function initTickerCounter() {}

  /* HERO IMAGE PARALLAX + SCALE ------------------------------------------- */
  function initHeroImageReveal() {
    const bg = document.querySelector('.hero__bg-img, .hero__bg-video');
    if (!bg) return;
    // Animate in on load
    bg.style.opacity   = '0';
    bg.style.transform = 'scale(1.12)';
    bg.style.transition = 'opacity 1200ms ease, transform 1400ms cubic-bezier(0.16,1,0.3,1)';

    setTimeout(() => {
      bg.style.opacity   = '0.28';
      bg.style.transform = 'scale(1.08)';
    }, 400);
  }

  /* NAV LINK HOVER — underline slides from accent _________________________ */
  function initNavHoverEffect() {
    document.querySelectorAll('.site-nav__link').forEach(link => {
      link.addEventListener('mouseenter', () => {
        link.style.transition = 'color 180ms ease';
      });
    });
  }

  /* HERO GLOBE ------------------------------------------------------------ */
  function initHeroCanvas() {
    const canvas = document.getElementById('hero-globe');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    let S;
    function resize() {
      S = canvas.offsetWidth > 10 ? canvas.offsetWidth : Math.round(window.innerWidth * 1.1);
      canvas.width  = S;
      canvas.height = S;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    const R   = 0.44; // globe radius as fraction of canvas size
    let   rot = 0;    // current rotation angle (radians)
    const SPEED = 0.0002; // radians per ms

    // Project 3D point on unit sphere to 2D canvas
    function project(lat, lon, angle) {
      const la = lat  * Math.PI / 180;
      const lo = (lon * Math.PI / 180) + angle;
      const x  = Math.cos(la) * Math.sin(lo);
      const y  = Math.sin(la);
      const z  = Math.cos(la) * Math.cos(lo);
      return { x, y, z };
    }

    // Draw a great-circle-like arc (latitude or longitude line)
    function drawLine(pts, alpha) {
      if (!pts.length) return;
      const r = S * R;
      const cx = S / 2, cy = S / 2;

      ctx.beginPath();
      let started = false;
      for (let i = 0; i < pts.length; i++) {
        const p = pts[i];
        if (p.z < 0) { started = false; continue; } // back-face cull
        const px = cx + p.x * r;
        const py = cy - p.y * r;
        const depth = (p.z + 1) / 2; // 0=back 1=front
        if (!started) { ctx.moveTo(px, py); started = true; }
        else ctx.lineTo(px, py);
      }
      ctx.strokeStyle = `rgba(201,168,76,${alpha})`;
      ctx.stroke();
    }

    function draw(ts) {
      try {
      ctx.clearRect(0, 0, S, S);
      rot = ts * SPEED;

      const r = S * R;
      const cx = S / 2, cy = S / 2;

      // Outer glow — no ctx.filter (breaks mobile Safari)
      const glow = ctx.createRadialGradient(cx, cy, r * 0.5, cx, cy, r * 1.4);
      glow.addColorStop(0,   'rgba(201,168,76,0.10)');
      glow.addColorStop(0.5, 'rgba(201,168,76,0.04)');
      glow.addColorStop(1,   'rgba(201,168,76,0)');
      ctx.fillStyle = glow;
      ctx.beginPath();
      ctx.arc(cx, cy, r * 1.4, 0, Math.PI * 2);
      ctx.fill();

      // Subtle hemisphere fill
      const fill = ctx.createRadialGradient(cx - r*0.2, cy - r*0.2, 0, cx, cy, r);
      fill.addColorStop(0,   'rgba(201,168,76,0.06)');
      fill.addColorStop(1,   'rgba(0,0,0,0)');
      ctx.fillStyle = fill;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.fill();

      ctx.lineWidth = 0.6;

      const STEPS = 64;

      // Latitude lines
      for (let lat = -80; lat <= 80; lat += 20) {
        const pts = [];
        for (let i = 0; i <= STEPS; i++) {
          pts.push(project(lat, (i / STEPS) * 360 - 180, rot));
        }
        const depth = Math.abs(lat) / 90;
        drawLine(pts, 0.18 - depth * 0.08);
      }

      // Longitude lines
      for (let lon = 0; lon < 360; lon += 20) {
        const pts = [];
        for (let i = 0; i <= STEPS; i++) {
          pts.push(project(-90 + (i / STEPS) * 180, lon, rot));
        }
        drawLine(pts, 0.14);
      }

      // Equator — slightly brighter
      ctx.lineWidth = 1.2;
      const eq = [];
      for (let i = 0; i <= STEPS * 2; i++) {
        eq.push(project(0, (i / (STEPS * 2)) * 360 - 180, rot));
      }
      drawLine(eq, 0.35);

      // Edge circle (limb)
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(201,168,76,0.22)';
      ctx.stroke();

      } catch(e) {}
      requestAnimationFrame(draw);
    }

    requestAnimationFrame(draw);
  }

  /* INIT ------------------------------------------------------------------ */
  function init() {
    initPageTransition();
    initHeroCanvas();
    initSectionReveals();
    initCardTilt();
    initLogoShimmer();
    initFooterReveal();
    initTickerCounter();
    initHeroImageReveal();
    initNavHoverEffect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ==========================================================================
   QUICK VIEW
   ========================================================================== */
(function() {
  var overlay, modal, imgEl, skeleton, brandEl, titleEl, priceEl, sizesEl,
      sizeErr, atcBtn, linkEl;
  var selectedVariantId = null;

  function init() {
    overlay  = document.getElementById('qv-overlay');
    if (!overlay) return;
    imgEl    = document.getElementById('qv-img');
    skeleton = document.getElementById('qv-img-skeleton');
    brandEl  = document.getElementById('qv-brand');
    titleEl  = document.getElementById('qv-title');
    priceEl  = document.getElementById('qv-price');
    sizesEl  = document.getElementById('qv-sizes');
    sizeErr  = document.getElementById('qv-size-err');
    atcBtn   = document.getElementById('qv-atc');
    linkEl   = document.getElementById('qv-link');

    document.getElementById('qv-close').addEventListener('click', close);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

    atcBtn.addEventListener('click', function() {
      if (!selectedVariantId) { sizeErr.style.display = 'block'; return; }
      sizeErr.style.display = 'none';
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
      }).then(function() {
        atcBtn.textContent = '✓ Added';
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          if (window.INBOUND_showShipToast) window.INBOUND_showShipToast(cart.total_price);
        }).catch(function() {});
        setTimeout(function() {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          close();
          /* bump cart count if header has one */
          var badge = document.querySelector('.cart-count');
          if (badge) { var n = (parseInt(badge.textContent)||0)+1; badge.textContent = n; badge.style.display = 'flex'; }
        }, 1200);
      }).catch(function() {
        atcBtn.textContent = 'Try Again';
        atcBtn.disabled = false;
      });
    });
  }

  function open() {
    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('qv-open');
    document.body.style.overflow = 'hidden';
    /* Force cursor elements above the backdrop-filter overlay */
    var dot = document.querySelector('.cursor__dot');
    var ring = document.querySelector('.cursor__ring');
    if (dot)  { dot.style.opacity  = '1'; dot.style.zIndex  = '99999'; }
    if (ring) { ring.style.opacity = '1'; ring.style.zIndex = '99998'; }
  }
  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('qv-open');
    document.body.style.overflow = '';
    selectedVariantId = null;
  }

  window.openQuickView = function(handle) {
    if (!overlay) init();
    if (!overlay) return;

    /* reset */
    selectedVariantId = null;
    sizesEl.innerHTML = '';
    sizeErr.style.display = 'none';
    atcBtn.textContent = 'Add to Cart';
    atcBtn.disabled = false;
    imgEl.classList.add('qv-loading');
    imgEl.classList.remove('qv-loaded');
    if (skeleton) skeleton.classList.remove('qv-hidden');
    brandEl.textContent = '';
    titleEl.textContent = '';
    priceEl.textContent = '';
    linkEl.href = '/products/' + handle;
    open();

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        brandEl.textContent = p.vendor;
        titleEl.textContent = p.title;
        linkEl.href = '/products/' + p.handle;

        /* price */
        var price = p.price_min;
        priceEl.textContent = '₹' + (price / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });

        /* image */
        if (p.images && p.images.length) {
          var src = p.images[0].replace('.jpg', '_900x.jpg').replace('.png', '_900x.png').replace('.webp', '_900x.webp');
          imgEl.src = src;
          imgEl.alt = p.title;
          imgEl.onload = function() {
            imgEl.classList.remove('qv-loading');
            imgEl.classList.add('qv-loaded');
            if (skeleton) skeleton.classList.add('qv-hidden');
          };
        }

        /* variants / sizes */
        var hasSize = p.variants.length > 1;
        if (hasSize) {
          p.variants.forEach(function(v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qv-size-btn';
            btn.textContent = v.option1;
            if (!v.available) btn.disabled = true;
            btn.addEventListener('click', function() {
              sizesEl.querySelectorAll('.qv-size-btn').forEach(function(b) { b.classList.remove('active'); });
              btn.classList.add('active');
              selectedVariantId = v.id;
              sizeErr.style.display = 'none';
            });
            sizesEl.appendChild(btn);
          });
        } else {
          selectedVariantId = p.variants[0].id;
        }
      })
      .catch(function() { close(); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── QV image preload on card hover ── */
  function attachPreloaders() {
    document.querySelectorAll('.product-card[data-qv-img]').forEach(function(card) {
      var preloaded = false;
      card.addEventListener('mouseenter', function() {
        if (preloaded) return;
        var src = card.getAttribute('data-qv-img');
        if (src) { var img = new Image(); img.src = src; preloaded = true; }
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachPreloaders);
  } else {
    attachPreloaders();
  }

  /* ── /cart page qty buttons — smooth, no reload ── */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.cart-page .qty-btn');
    if (!btn) return;
    var line = parseInt(btn.dataset.line);
    var qty  = parseInt(btn.dataset.qty);
    if (isNaN(line) || isNaN(qty)) return;
    var newQty = btn.dataset.action === 'increment' ? qty + 1 : Math.max(0, qty - 1);

    // Optimistic UI — update qty display immediately
    var control = btn.closest('.qty-control');
    var qtyVal  = control && control.querySelector('.qty-val');
    if (qtyVal) qtyVal.textContent = newQty;
    control && control.querySelectorAll('.qty-btn').forEach(function(b) { b.dataset.qty = newQty; });

    try {
      var res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      });
      var cart = await res.json();
      if (!res.ok) throw new Error(cart.message || 'Cart update failed');

      // Item removed — reload to show empty state
      if (newQty === 0) { window.location.reload(); return; }

      // Update line price
      var row = document.querySelector('.cart-row[data-line="' + line + '"]');
      if (row && cart.items[line - 1]) {
        var priceEl = row.querySelector('[data-line-price]');
        if (priceEl) priceEl.textContent = formatMoney(cart.items[line - 1].final_line_price);
      }

      // Update totals
      document.querySelectorAll('[data-cart-total]').forEach(function(el) {
        el.textContent = formatMoney(cart.total_price);
      });
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });

      // Refresh shipping progress bar + row on the cart page
      var pageBar = document.querySelector('[data-ship-bar-page]');
      if (pageBar) pageBar.outerHTML = shipBarHTML(cart.total_price).replace('data-ship-bar', 'data-ship-bar-page');
      var pageShipRow = document.querySelector('[data-ship-row]');
      if (pageShipRow) {
        var nowFree = cart.total_price >= FREE_SHIP_THRESHOLD;
        pageShipRow.textContent = nowFree ? 'Free' : formatMoney(19900);
        pageShipRow.style.color = nowFree ? '#4ade80' : 'rgba(255,255,255,0.7)';
        pageShipRow.style.webkitTextFillColor = nowFree ? '#4ade80' : 'rgba(255,255,255,0.7)';
      }
    } catch(err) {
      // Revert on error
      if (qtyVal) qtyVal.textContent = qty;
      control && control.querySelectorAll('.qty-btn').forEach(function(b) { b.dataset.qty = qty; });
    }
  });
})();

